import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { ProductLabel } from '@/types/productServerApi';
import useGlobalLabels from '@/shared/content/useGlobalLabels';
import { GlobalLabels } from '@/shared/content/site-context.store';
import SplashLabel from '@/shared/content/blocks/helpers/SplashLabel.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProductSplashLabelCustomize',
  props: {
    label: null
  },
  setup(__props: any) {




const { splashLabelCustomize } = useGlobalLabels(GlobalLabels.product);


return (_ctx: any,_cache: any) => {
  return (__props.label)
    ? (_openBlock(), _createBlock(SplashLabel, {
        key: 0,
        class: "bg-brandy",
        "background-color": __props.label.backgroundColorHex,
        label: _unref(splashLabelCustomize)
      }, null, 8, ["background-color", "label"]))
    : _createCommentVNode("", true)
}
}

})